var target_tab;
$(".monphai-tab-item").click(function(e) {
    e.preventDefault();
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    target_tab =  $(this).data('target');
    $(this).parent().siblings().find('.monphai-info--feature-item').removeClass("active");
    $(this).parent().siblings().find('.monphai-info--feature-item-'+ target_tab).addClass("active");

});